document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  /*
  =====================================================
  Shared helpers
  =====================================================
  */

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function normalizeQuantity(value) {
    const parsedValue = Number.parseInt(value, 10);

    if (!Number.isFinite(parsedValue) || parsedValue < 1) {
      return 1;
    }

    return parsedValue;
  }

  /*
  =====================================================
  Product gallery
  =====================================================
  */

  const mainImageWrapper = document.querySelector(
    '.me-main-product__image-main'
  );

  const galleryThumbs = document.querySelectorAll(
    '[data-me-product-thumb]'
  );

  if (mainImageWrapper && galleryThumbs.length) {
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const newSource = thumb.getAttribute(
          'data-me-product-thumb'
        );

        const mainImage = mainImageWrapper.querySelector('img');

        if (!mainImage || !newSource) return;

        mainImage.src = newSource;
        mainImage.srcset = '';
      });
    });
  }

  /*
  =====================================================
  Product-family color cards
  =====================================================
  */

  const catalog = window.MECatalog;

  const colorBlock = document.querySelector(
    '[data-me-family]'
  );

  const colorContainer = document.querySelector(
    '[data-me-catalog-colors]'
  );

  if (catalog && colorBlock && colorContainer) {
    const familyKey = colorBlock.dataset.meFamily;
    const currentHandle = colorBlock.dataset.meCurrentHandle;

    const family =
      catalog.families &&
      catalog.families[familyKey];

    if (
      family &&
      Array.isArray(family.colors) &&
      family.colors.length
    ) {
      colorContainer.innerHTML = family.colors
        .map((color) => {
          const activeClass =
            color.handle === currentHandle
              ? 'is-active'
              : '';

          const productUrl = `/products/${color.handle}`;
          const productJsonUrl = `${productUrl}.js`;

          return `
            <a
              href="${productUrl}"
              class="me-af-color-card ${activeClass}"
              data-me-product-json="${productJsonUrl}"
            >
              <span class="me-af-color-card__image">
                <span class="me-af-color-card__placeholder"></span>
              </span>

              <span class="me-af-color-card__name">
                ${escapeHtml(color.name)}
              </span>

              <span class="me-af-color-card__status">
                Checking stock...
              </span>
            </a>
          `;
        })
        .join('');

      const colorCards = document.querySelectorAll(
        '[data-me-product-json]'
      );

      colorCards.forEach(async (card) => {
        try {
          const response = await fetch(
            card.dataset.meProductJson
          );

          if (!response.ok) return;

          const productData = await response.json();

          const image =
            productData.featured_image ||
            productData.images?.[0];

          if (image) {
            const imageWrapper = card.querySelector(
              '.me-af-color-card__image'
            );

            if (imageWrapper) {
              imageWrapper.innerHTML = `
                <img
                  src="${image}"
                  alt="${escapeHtml(productData.title)}"
                  loading="lazy"
                >
              `;
            }
          }

          const variants = Array.isArray(productData.variants)
            ? productData.variants
            : [];

          const availableVariants = variants.filter(
            (variant) => variant.available
          );

          const totalInventory = variants.reduce(
            (total, variant) => {
              if (
                typeof variant.inventory_quantity ===
                'number'
              ) {
                return (
                  total +
                  Math.max(
                    variant.inventory_quantity,
                    0
                  )
                );
              }

              return total;
            },
            0
          );

          const statusElement = card.querySelector(
            '.me-af-color-card__status'
          );

          if (!statusElement) return;

          statusElement.classList.remove(
            'is-stock',
            'is-low',
            'is-backorder'
          );

          if (!availableVariants.length) {
            statusElement.textContent =
              '● Backorder Available';

            statusElement.classList.add(
              'is-backorder'
            );
          } else if (
            totalInventory > 0 &&
            totalInventory < 20
          ) {
            statusElement.textContent =
              '● Low Stock';

            statusElement.classList.add(
              'is-low'
            );
          } else {
            statusElement.textContent =
              '● In Stock';

            statusElement.classList.add(
              'is-stock'
            );
          }
        } catch (error) {
          console.warn(
            'Could not load color product:',
            error
          );
        }
      });
    }
  }

  /*
  =====================================================
  Size picker
  =====================================================
  */

  const sizeButtons = document.querySelectorAll(
    '[data-me-size-button]'
  );

  const selectedSizeLabel = document.querySelector(
    '[data-me-selected-size]'
  );

  const variantIdInput = document.querySelector(
    '[data-me-variant-id]'
  );

  const productPrice = document.querySelector(
    '[data-me-product-price]'
  );

  const addToCartButton = document.querySelector(
    '.me-main-product__button'
  );

  sizeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      if (button.disabled) return;

      const variantId =
        button.dataset.variantId;

      const variantTitle =
        button.dataset.variantTitle;

      const variantPrice =
        button.dataset.variantPrice;

      const variantAvailable =
        button.dataset.variantAvailable === 'true';

      sizeButtons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute(
          'aria-pressed',
          'false'
        );
      });

      button.classList.add('is-active');
      button.setAttribute(
        'aria-pressed',
        'true'
      );

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      if (selectedSizeLabel && variantTitle) {
        selectedSizeLabel.textContent =
          `Selected: ${variantTitle}`;
      }

      if (productPrice && variantPrice) {
        productPrice.textContent =
          variantPrice;
      }

      if (addToCartButton) {
        addToCartButton.disabled =
          !variantAvailable;

        addToCartButton.textContent =
          variantAvailable
            ? 'Add to Cart'
            : 'Unavailable';
      }

      if (
        variantId &&
        window.history?.replaceState
      ) {
        const url = new URL(
          window.location.href
        );

        url.searchParams.set(
          'variant',
          variantId
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    });
  });

  /*
  =====================================================
  Quantity picker
  =====================================================
  */

  const quantityInput = document.querySelector(
    '[data-me-quantity-input]'
  );

  const decreaseQuantityButton =
    document.querySelector(
      '[data-me-quantity-minus]'
    );

  const increaseQuantityButton =
    document.querySelector(
      '[data-me-quantity-plus]'
    );

  if (
    decreaseQuantityButton &&
    quantityInput
  ) {
    decreaseQuantityButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const currentValue =
          normalizeQuantity(
            quantityInput.value
          );

        quantityInput.value = Math.max(
          1,
          currentValue - 1
        );

        quantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );
  }

  if (
    increaseQuantityButton &&
    quantityInput
  ) {
    increaseQuantityButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const currentValue =
          normalizeQuantity(
            quantityInput.value
          );

        quantityInput.value =
          currentValue + 1;

        quantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );
  }

  if (quantityInput) {
    quantityInput.addEventListener(
      'change',
      () => {
        quantityInput.value =
          normalizeQuantity(
            quantityInput.value
          );
      }
    );
  }

  /*
  =====================================================
  Artwork upload elements
  =====================================================
  */

  const artworkInput = document.querySelector(
    '[data-me-artwork-input]'
  );

  const uploadZone = document.querySelector(
    '[data-me-upload-zone]'
  );

  const artworkResult = document.querySelector(
    '[data-me-artwork-result]'
  );

  const artworkPreview = document.querySelector(
    '[data-me-artwork-preview]'
  );

  const artworkName = document.querySelector(
    '[data-me-artwork-name]'
  );

  const artworkDimensions = document.querySelector(
    '[data-me-artwork-dimensions]'
  );

  const removeArtworkButton = document.querySelector(
    '[data-me-remove-artwork]'
  );

  const validationBox = document.querySelector(
    '[data-me-artwork-validation]'
  );

  const qualityBox = document.querySelector(
    '[data-me-print-quality]'
  );

  const optimizationBox = document.querySelector(
    '[data-me-artwork-optimization]'
  );

  const optimizationHeading = document.querySelector(
    '[data-me-optimization-heading]'
  );

  const optimizationMessage = document.querySelector(
    '[data-me-optimization-message]'
  );

  const optimizationProperty = document.querySelector(
    '[data-me-optimization-property]'
  );

  const reviewStatusProperty = document.querySelector(
    '[data-me-review-status-property]'
  );

  const placementButtons = document.querySelectorAll(
    '[data-me-placement-button]'
  );

  const placementValueInput = document.querySelector(
    '[data-me-placement-value]'
  );

  let currentArtwork = null;
  let selectedPrintWidth = 4;

  /*
  =====================================================
  Placement controls
  =====================================================
  */

  placementButtons.forEach((button) => {
    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        const placementName =
          button.dataset.placementName ||
          'Left Chest';

        const printWidth = Number(
          button.dataset.printWidth
        );

        placementButtons.forEach((item) => {
          item.classList.remove(
            'is-active'
          );

          item.setAttribute(
            'aria-pressed',
            'false'
          );
        });

        button.classList.add(
          'is-active'
        );

        button.setAttribute(
          'aria-pressed',
          'true'
        );

        if (placementValueInput) {
          placementValueInput.value =
            placementName;
        }

        if (
          Number.isFinite(printWidth) &&
          printWidth > 0
        ) {
          selectedPrintWidth =
            printWidth;
        }

        if (currentArtwork) {
          updateEffectiveDpi(
            currentArtwork.width,
            currentArtwork.height,
            selectedPrintWidth
          );
        }
      }
    );
  });

  /*
  =====================================================
  Artwork input
  =====================================================
  */

  if (artworkInput) {
    artworkInput.addEventListener(
      'change',
      () => {
        const file =
          artworkInput.files?.[0];

        if (!file) {
          resetArtwork();
          return;
        }

        validateArtwork(file);
      }
    );
  }

  if (removeArtworkButton) {
    removeArtworkButton.addEventListener(
      'click',
      resetArtwork
    );
  }

  /*
  =====================================================
  Drag and drop
  =====================================================
  */

  if (uploadZone && artworkInput) {
    ['dragenter', 'dragover'].forEach(
      (eventName) => {
        uploadZone.addEventListener(
          eventName,
          (event) => {
            event.preventDefault();

            uploadZone.classList.add(
              'is-dragging'
            );
          }
        );
      }
    );

    ['dragleave', 'drop'].forEach(
      (eventName) => {
        uploadZone.addEventListener(
          eventName,
          (event) => {
            event.preventDefault();

            uploadZone.classList.remove(
              'is-dragging'
            );
          }
        );
      }
    );

    uploadZone.addEventListener(
      'drop',
      (event) => {
        const file =
          event.dataTransfer?.files?.[0];

        if (!file) return;

        try {
          const transfer =
            new DataTransfer();

          transfer.items.add(file);
          artworkInput.files =
            transfer.files;
        } catch (error) {
          console.warn(
            'Could not assign dropped file:',
            error
          );
        }

        validateArtwork(file);
      }
    );
  }

  /*
  =====================================================
  Validate artwork
  =====================================================
  */

  function validateArtwork(file) {
    const maximumBytes =
      25 * 1024 * 1024;

    const isPng =
      file.type === 'image/png' ||
      file.name
        .toLowerCase()
        .endsWith('.png');

    showValidation();

    setValidationStatus(
      '[data-me-validation-format]',
      isPng ? 'success' : 'error',
      isPng
        ? 'PNG file detected.'
        : 'Please upload a PNG file.'
    );

    if (!isPng) {
      setSummary(
        'error',
        'This file cannot be used. Please upload a PNG.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      return;
    }

    if (file.size > maximumBytes) {
      setSummary(
        'error',
        'This file is larger than 25 MB. Please upload a smaller PNG.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      return;
    }

    if (
      currentArtwork &&
      currentArtwork.objectUrl
    ) {
      URL.revokeObjectURL(
        currentArtwork.objectUrl
      );
    }

    const objectUrl =
      URL.createObjectURL(file);

    const image = new Image();

    image.onload = () => {
      const width =
        image.naturalWidth;

      const height =
        image.naturalHeight;

      currentArtwork = {
        file,
        width,
        height,
        objectUrl
      };

      if (artworkPreview) {
        artworkPreview.src =
          objectUrl;
      }

      if (artworkName) {
        artworkName.textContent =
          file.name;
      }

      if (artworkDimensions) {
        artworkDimensions.textContent =
          `${width.toLocaleString()} × ` +
          `${height.toLocaleString()} pixels`;
      }

      if (artworkResult) {
        artworkResult.hidden =
          false;
      }

      if (uploadZone) {
        uploadZone.classList.add(
          'has-file'
        );
      }

      const dimensionsPass =
        width >= 1200 &&
        height >= 1000;

      setValidationStatus(
        '[data-me-validation-dimensions]',
        dimensionsPass
          ? 'success'
          : 'warning',
        `${width.toLocaleString()} × ` +
          `${height.toLocaleString()} pixels`
      );

      detectTransparency(
        image,
        width,
        height
      );

      updateEffectiveDpi(
        width,
        height,
        selectedPrintWidth
      );
    };

    image.onerror = () => {
      setSummary(
        'error',
        'This PNG could not be read. Please try another file.'
      );

      if (artworkInput) {
        artworkInput.value = '';
      }

      URL.revokeObjectURL(
        objectUrl
      );
    };

    image.src = objectUrl;
  }

  /*
  =====================================================
  Transparency detection
  =====================================================
  */

  function detectTransparency(
    image,
    width,
    height
  ) {
    try {
      const canvas =
        document.createElement(
          'canvas'
        );

      const context =
        canvas.getContext(
          '2d',
          {
            willReadFrequently: true
          }
        );

      if (!context) {
        setValidationStatus(
          '[data-me-validation-transparency]',
          'warning',
          'Transparency could not be checked automatically.'
        );

        return;
      }

      const sampleWidth =
        Math.min(width, 600);

      const sampleHeight =
        Math.max(
          1,
          Math.round(
            height *
              (sampleWidth / width)
          )
        );

      canvas.width =
        sampleWidth;

      canvas.height =
        sampleHeight;

      context.clearRect(
        0,
        0,
        sampleWidth,
        sampleHeight
      );

      context.drawImage(
        image,
        0,
        0,
        sampleWidth,
        sampleHeight
      );

      const pixels =
        context.getImageData(
          0,
          0,
          sampleWidth,
          sampleHeight
        ).data;

      let transparentPixelFound =
        false;

      for (
        let index = 3;
        index < pixels.length;
        index += 4
      ) {
        if (pixels[index] < 250) {
          transparentPixelFound =
            true;

          break;
        }
      }

      setValidationStatus(
        '[data-me-validation-transparency]',
        transparentPixelFound
          ? 'success'
          : 'warning',
        transparentPixelFound
          ? 'Transparent background detected.'
          : 'No transparent background detected. The artwork may print with a solid background.'
      );
    } catch (error) {
      console.warn(
        'Transparency check failed:',
        error
      );

      setValidationStatus(
        '[data-me-validation-transparency]',
        'warning',
        'Transparency could not be checked automatically.'
      );
    }
  }

  /*
  =====================================================
  Print quality helpers
  =====================================================
  */

  function getPrintQuality(dpi) {
    if (dpi >= 300) {
      return {
        rating: 'Excellent',
        status: 'success',
        stars: 5
      };
    }

    if (dpi >= 250) {
      return {
        rating: 'Very Good',
        status: 'success',
        stars: 4
      };
    }

    if (dpi >= 200) {
      return {
        rating: 'Good',
        status: 'warning',
        stars: 3
      };
    }

    if (dpi >= 150) {
      return {
        rating: 'Fair',
        status: 'warning',
        stars: 2
      };
    }

    return {
      rating: 'Low Resolution',
      status: 'error',
      stars: 1
    };
  }

  function updateEffectiveDpi(
    width,
    height,
    suppliedPrintWidth
  ) {
    try {
      let printWidth = Number(
        suppliedPrintWidth
      );

      if (
        !Number.isFinite(printWidth) ||
        printWidth <= 0
      ) {
        printWidth =
          selectedPrintWidth;
      }

      if (
        !Number.isFinite(printWidth) ||
        printWidth <= 0
      ) {
        printWidth = 4;
      }

      if (
        !Number.isFinite(width) ||
        width <= 0
      ) {
        return;
      }

      const effectiveDpi =
        Math.round(
          width / printWidth
        );

      const quality =
        getPrintQuality(
          effectiveDpi
        );

      setValidationStatus(
        '[data-me-validation-dpi]',
        quality.status,
        `${effectiveDpi} effective DPI at approximately ${printWidth} inches wide.`
      );

      if (
        quality.status ===
        'success'
      ) {
        setSummary(
          'success',
          'Artwork quality looks suitable for the selected print location.'
        );
      } else if (
        quality.status ===
        'warning'
      ) {
        setSummary(
          'warning',
          'The artwork may be usable, but review the print-quality recommendations below.'
        );
      } else {
        setSummary(
          'error',
          'A higher-resolution PNG is recommended for this print location.'
        );
      }

      updatePrintQualityReport(
        width,
        printWidth
      );

      updateArtworkOptimization(
        effectiveDpi,
        printWidth
      );
    } catch (error) {
      console.warn(
        'DPI and artwork-quality calculation failed:',
        error
      );
    }
  }

  function updatePrintQualityReport(
    imageWidth,
    currentPrintWidth
  ) {
    if (!qualityBox) return;

    const currentDpi =
      Math.round(
        imageWidth /
          currentPrintWidth
      );

    const currentQuality =
      getPrintQuality(
        currentDpi
      );

    const starsElement =
      qualityBox.querySelector(
        '[data-me-quality-stars]'
      );

    const ratingElement =
      qualityBox.querySelector(
        '[data-me-quality-rating]'
      );

    const dpiElement =
      qualityBox.querySelector(
        '[data-me-quality-current-dpi]'
      );

    const recommendedElement =
      qualityBox.querySelector(
        '[data-me-quality-recommended]'
      );

    const warningsElement =
      qualityBox.querySelector(
        '[data-me-quality-warnings]'
      );

    const placements = [
      {
        name: 'Left Chest',
        width: 4
      },
      {
        name: 'Hat Logo',
        width: 3.5
      },
      {
        name: 'Left Sleeve',
        width: 3.5
      },
      {
        name: 'Right Sleeve',
        width: 3.5
      },
      {
        name: 'Full Front',
        width: 11
      },
      {
        name: 'Full Back',
        width: 11
      }
    ];

    const recommended = [];
    const warnings = [];

    placements.forEach(
      (placement) => {
        const placementDpi =
          Math.round(
            imageWidth /
              placement.width
          );

        if (
          placementDpi >= 250
        ) {
          recommended.push({
            ...placement,
            dpi: placementDpi
          });
        } else {
          warnings.push({
            ...placement,
            dpi: placementDpi
          });
        }
      }
    );

    if (starsElement) {
      starsElement.textContent =
        '★'.repeat(
          currentQuality.stars
        ) +
        '☆'.repeat(
          5 -
            currentQuality.stars
        );
    }

    if (ratingElement) {
      ratingElement.textContent =
        currentQuality.rating;
    }

    if (dpiElement) {
      dpiElement.textContent =
        `${currentDpi} Effective DPI`;
    }

    qualityBox.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    qualityBox.classList.add(
      `is-${currentQuality.status}`
    );

    if (recommendedElement) {
      recommendedElement.innerHTML =
        recommended.length
          ? recommended
              .map(
                (item) => `
                  <div class="me-print-quality__recommendation">
                    <span>✓</span>

                    <span>
                      ${escapeHtml(item.name)}
                      <small>${item.dpi} DPI</small>
                    </span>
                  </div>
                `
              )
              .join('')
          : `
              <div class="me-print-quality__recommendation is-empty">
                A higher-resolution image is recommended for all listed placements.
              </div>
            `;
    }

    if (warningsElement) {
      warningsElement.innerHTML =
        warnings
          .map(
            (item) => `
              <div class="me-print-quality__warning">
                <span>⚠</span>

                <span>
                  ${escapeHtml(item.name)}
                  will reduce quality to
                  <strong>${item.dpi} DPI</strong>.
                </span>
              </div>
            `
          )
          .join('');
    }

    qualityBox.hidden = false;
  }

  /*
  =====================================================
  Artwork optimization/review notice
  =====================================================
  */

  function updateArtworkOptimization(
    effectiveDpi,
    printWidth
  ) {
    if (!optimizationBox) return;

    const optimizationIcon =
      optimizationBox.querySelector(
        '.me-artwork-optimization__icon'
      );

    optimizationBox.hidden =
      false;

    optimizationBox.classList.remove(
      'is-standard',
      'is-optimization',
      'is-review'
    );

    if (effectiveDpi >= 300) {
      optimizationBox.classList.add(
        'is-standard'
      );

      if (optimizationIcon) {
        optimizationIcon.textContent =
          '✓';
      }

      if (optimizationHeading) {
        optimizationHeading.textContent =
          'Artwork Quality Review Included';
      }

      if (optimizationMessage) {
        optimizationMessage.textContent =
          `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide and should produce excellent print quality.`;
      }

      if (optimizationProperty) {
        optimizationProperty.value =
          'Not required — artwork meets recommended quality';
      }

      if (reviewStatusProperty) {
        reviewStatusProperty.value =
          'Standard review';
      }

      return;
    }

    if (effectiveDpi >= 150) {
      optimizationBox.classList.add(
        'is-optimization'
      );

      if (optimizationIcon) {
        optimizationIcon.textContent =
          '✦';
      }

      if (optimizationHeading) {
        optimizationHeading.textContent =
          'Automatic Artwork Optimization Included';
      }

      if (optimizationMessage) {
        optimizationMessage.textContent =
          `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide. We will optimize it when possible before production.`;
      }

      if (optimizationProperty) {
        optimizationProperty.value =
          'Automatic optimization included';
      }

      if (reviewStatusProperty) {
        reviewStatusProperty.value =
          'Optimization review required';
      }

      return;
    }

    optimizationBox.classList.add(
      'is-review'
    );

    if (optimizationIcon) {
      optimizationIcon.textContent =
        '!';
    }

    if (optimizationHeading) {
      optimizationHeading.textContent =
        'Artwork Review Required';
    }

    if (optimizationMessage) {
      optimizationMessage.textContent =
        `This artwork is approximately ${effectiveDpi} DPI at ${printWidth} inches wide and may appear blurry. We will review it and contact you only if a better file is required.`;
    }

    if (optimizationProperty) {
      optimizationProperty.value =
        'Optimization attempted when possible';
    }

    if (reviewStatusProperty) {
      reviewStatusProperty.value =
        'Manual review required';
    }
  }

  /*
  =====================================================
  Validation UI helpers
  =====================================================
  */

  function showValidation() {
    if (validationBox) {
      validationBox.hidden =
        false;
    }
  }

  function setValidationStatus(
    selector,
    status,
    message
  ) {
    const item =
      document.querySelector(
        selector
      );

    if (!item) return;

    const icon =
      item.querySelector(
        '.me-artwork-validation__icon'
      );

    const text =
      item.querySelector(
        '.me-artwork-validation__text'
      );

    item.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    item.classList.add(
      `is-${status}`
    );

    if (icon) {
      icon.textContent =
        status === 'success'
          ? '✓'
          : status === 'error'
            ? '!'
            : '⚠';
    }

    if (text) {
      text.textContent =
        message;
    }
  }

  function setSummary(
    status,
    message
  ) {
    const summary =
      document.querySelector(
        '[data-me-validation-summary]'
      );

    if (!summary) return;

    summary.classList.remove(
      'is-success',
      'is-warning',
      'is-error'
    );

    summary.classList.add(
      `is-${status}`
    );

    summary.textContent =
      message;
  }

  /*
  =====================================================
  Reset artwork
  =====================================================
  */

  function resetArtwork() {
    if (
      currentArtwork &&
      currentArtwork.objectUrl
    ) {
      URL.revokeObjectURL(
        currentArtwork.objectUrl
      );
    }

    currentArtwork = null;

    if (artworkInput) {
      artworkInput.value = '';
    }

    if (artworkPreview) {
      artworkPreview.src = '';
    }

    if (artworkResult) {
      artworkResult.hidden =
        true;
    }

    if (validationBox) {
      validationBox.hidden =
        true;
    }

    if (qualityBox) {
      qualityBox.hidden =
        true;
    }

    if (optimizationBox) {
      optimizationBox.hidden =
        true;

      optimizationBox.classList.remove(
        'is-standard',
        'is-optimization',
        'is-review'
      );
    }

    if (optimizationProperty) {
      optimizationProperty.value =
        'Not required';
    }

    if (reviewStatusProperty) {
      reviewStatusProperty.value =
        'Standard review';
    }

    if (uploadZone) {
      uploadZone.classList.remove(
        'has-file',
        'is-dragging'
      );
    }
  }
});